export const enJoinUsersFinished = {
  SB22title: ' Registered in the community.',
  SB22title2: 'Registered in the community.',
  SB22Top: 'Top',
  SB22description: 'I have completed my initial registration and have joined the community. After logging in, please use the community.',
  SB22description2: 'I have completed my initial registration and have joined the community. After logging in, please use the community.',
}
